import { render, staticRenderFns } from "./GeralResults.vue?vue&type=template&id=57d1c1be&"
import script from "./GeralResults.vue?vue&type=script&lang=js&"
export * from "./GeralResults.vue?vue&type=script&lang=js&"
import style0 from "./GeralResults.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "GeralResults.vue"
export default component.exports